if (!customElements.get('aka-order-note')) {
  customElements.define('aka-order-note', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const { signal } = this.events;
      const dropdown = this.querySelector('details');
      const textarea = this.querySelector('textarea');
      const label = this.querySelector('[data-note-label]');
      if (!dropdown || !textarea || !label) return;
      const updateLabel = () => { label.textContent = textarea.value.trim() ? 'Edit your order note' : 'Add a note to your order'; };
      this.openNote = () => {
        dropdown.open = true;
        textarea.focus({ preventScroll: true });
      };
      textarea.addEventListener('input', updateLabel, { signal });
      // The add-to-cart notification links here without changing cart behavior.
      const openFromHash = () => {
        if (window.location.hash === '#' + this.id) this.openNote();
      };
      window.addEventListener('hashchange', openFromHash, { signal });
      updateLabel();
      openFromHash();
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
